module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House24.fd0d45cf.jpg";